import React from 'react';
import * as styles from '../../styles/containers/DashboardEditor.less';

interface DashboardCheckboxProps {
  id: string;
  label: string;
  defaultChecked: boolean;
  // The DashboardEditor handlers read the toggled value back via
  // `getElementById(id).checked`, so they ignore the event — but typing this as a
  // proper change handler keeps the door open for reading `e.target.checked`.
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
  title?: string;
}

// One cell-pair of the DashboardEditor's checkbox grid: the `pure-u-1-24` input
// followed by the `pure-u-7-24` label. Rendered as a fragment so it drops
// straight into the interleaved `chartSelector` rows without adding a wrapper
// node (the grid layout depends on these two divs being direct siblings).
//
// UNCONTROLLED by design (`defaultChecked`, never `checked`) — see the editor's
// note on tick-lag. `onChange` replaces the old mix of `onClick`/`onChange`;
// for a checkbox they fire equivalently (after the DOM has toggled), and
// `onChange` also covers keyboard toggling.
//
// `React.memo` lets an unchanged box skip re-rendering when the big editor
// re-renders on a tick. It only fully pays off once the editor's handlers get
// stable identities (Phase 4b: controlled checkboxes + removing the
// getElementById machinery); until then the per-box `onChange` identity still
// changes each render. Harmless now, effective later.
const DashboardCheckbox = ({ id, label, defaultChecked, onChange, disabled, title }: DashboardCheckboxProps) => (
  <>
    <div className="pure-u-1-24">
      <input
        id={id}
        type="checkbox"
        title={title}
        defaultChecked={defaultChecked}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
    <div className="pure-u-7-24">
      <label className={styles.label}>{label}</label>
    </div>
  </>
);

export default React.memo(DashboardCheckbox);
